import { render } from "./scanning.vue?vue&type=template&id=4c213c54&scoped=true"
const script = {}

import "./scanning.vue?vue&type=style&index=0&id=4c213c54&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c213c54"]])

export default __exports__